export class MonthPelletizingProductQuality {
    constructor({
          id= null,       
          month= ``,
          locName= ``,  
          productName= ``,
          monthStr='',
          code='',
        
      } = {}) {
      this.id = id;     
      this.code=code; 
      this.month = month;
      this.locName = locName;     
      this.productName = productName;
      this.monthStr=monthStr;
      
    }
  }
  export function gridFields() {
    return Object.freeze([  
      {
        key: 'code',
        label: 'lbl.basic.code',
        sortable: true,
        form: {
          type: 'input'
        }
      },  
      {
          key: 'locName',
          label: 'lbl.basic.locName',
          sortable: true,
          form: {
            type: 'input'
          }
        }, 
        {
          key: 'monthStr',
          label: 'lbl.basic.month',
          sortable: true,
          form: {
            type: 'input'
          }
        },                            
        {
          key: 'productName',
          label: 'lbl.prd.execution.productionName',
          sortable: false,
          form: {
            type: 'input'
          }
        }, 
        
    ]);
  }
  export const fields = Object.freeze(Object.keys(new MonthPelletizingProductQuality()).map(i => 'entity.' + i));
  export const filterFields = [
    'filter.plantFilter',
    'filter.startMonthFilter',
    'filter.endMonthFilter',     
  ];
  export const filter = {
    'plantFilter': "",
    'startMonthFilter': "",
    'endMonthFilter': "",
  };